import { Component } from '@angular/core';
import { SHARED_IMPORTS } from '../../shared-imports';

@Component({
  selector: 'syn-certified-assessment-icon',
  templateUrl: './certified-assessment-icon.component.html',
  styleUrls: ['./certified-assessment-icon.component.scss'],
  imports: [SHARED_IMPORTS],
})
export class CertifiedAssessmentIconComponent {}
